/* Boletin — "El cable", parte 1 y 2.
   - Recorrido ORTOGONAL anclado a los margenes. Sin diagonales.
   - No ligado al scroll: se dispara una vez al llegar la seccion y corre a
     540px/s. Cada bloque entra cuando la cabeza del cable lo pasa.
   - Es un TUBO, no una linea: el mismo `d` tres veces (cuerpo, filo, sombra).
   - Se mide por cadena de offsets, nunca con getBoundingClientRect (el rect
     arrastra el translateY de entrada). El cruce va 10px por debajo de la
     regla del campo (7 en angosto).
   - La chispa: UNA esfera, una sola pasada, 1450px/s (excepcion declarada).
     Al pasar el 93% del recorrido emite eq:corriente (enciende el club).
   - La suscripcion manda corriente VERDE solo si el correo es valido, con freno
     de una chispa cada 5s. */
const { mount, reduced, yaVisto, marcarVisto } = window.EQ;

const SPEED = 540;
const OVER = 26;
const OPEN = 'inset(-18px)';

mount('[data-eq-boletin]', (sec) => {
  const q = (sel) => sec.querySelector(sel);
  const qa = (sel) => Array.from(sec.querySelectorAll(sel));
  const cables = () => ['[data-eq-cable-body]', '[data-eq-cable-lo]', '[data-eq-cable-hi]'].map(q).filter(Boolean);
  const lento = reduced();
  let corrio = false, L = 0, blocks = [], lrA = null, lrB = null, lwA = null, lwB = null;
  let io = null, guard = 0, tRes = 0, rafC = 0, tChispa = 0, timers = [], colorPend = null, enviando = false;

  const off = (el) => {
    let x = 0, y = 0, n = el;
    while (n && n !== sec && n.offsetParent !== undefined) {
      x += n.offsetLeft; y += n.offsetTop;
      if (n.offsetParent === sec || !n.offsetParent) break;
      n = n.offsetParent;
    }
    return { x, y, w: el.offsetWidth, h: el.offsetHeight, r: x + el.offsetWidth, b: y + el.offsetHeight };
  };

  // listado de puntos con el temblor (opcional) perpendicular al avance,
  // suavizado por cuadraticas. Se calcula una vez por layout y queda congelado.
  const puntos = (xa, xb, yc, R, H, amp) => {
    const pts = [];
    let s = 0;
    const fase = (xb * 0.013) % 6.283;
    const onda = (len) => amp * Math.sin((len / 240) * 6.283 + fase);
    const step = 15;
    const leg = (x0, y0, x1, y1) => {
      const dx = x1 - x0, dy = y1 - y0, len = Math.hypot(dx, dy);
      if (len < 1) return;
      const ux = dx / len, uy = dy / len, nx = -uy, ny = ux;
      const n = Math.max(1, Math.round(len / step));
      for (let i = pts.length ? 1 : 0; i <= n; i++) {
        const t = i / n, d = onda(s + len * t);
        pts.push({ x: x0 + dx * t + nx * d, y: y0 + dy * t + ny * d });
      }
      s += len;
    };
    const esquina = (x0, y0, cx, cy, x1, y1) => {
      for (let i = 1; i <= 7; i++) {
        const t = i / 7, u = 1 - t;
        pts.push({ x: u * u * x0 + 2 * u * t * cx + t * t * x1, y: u * u * y0 + 2 * u * t * cy + t * t * y1 });
      }
      s += R * 1.6;
    };
    leg(xa, 0, xa, yc - R);
    esquina(xa, yc - R, xa, yc, xa + R, yc);
    leg(xa + R, yc, xb - R, yc);
    esquina(xb - R, yc, xb, yc, xb, yc + R);
    leg(xb, yc + R, xb, H);
    return pts;
  };
  const suave = (pts) => {
    if (pts.length < 3) return '';
    let d = 'M ' + pts[0].x.toFixed(1) + ' ' + pts[0].y.toFixed(1);
    for (let i = 1; i < pts.length - 1; i++) {
      const mx = (pts[i].x + pts[i + 1].x) / 2, my = (pts[i].y + pts[i + 1].y) / 2;
      d += ' Q ' + pts[i].x.toFixed(1) + ' ' + pts[i].y.toFixed(1) + ' ' + mx.toFixed(1) + ' ' + my.toFixed(1);
    }
    const l = pts[pts.length - 1];
    return d + ' L ' + l.x.toFixed(1) + ' ' + l.y.toFixed(1);
  };

  const layout = () => {
    const svg = q('[data-eq-cable]'), body = q('[data-eq-cable-body]'), band = q('[data-eq-band]');
    if (!svg || !body || !band) return;
    const sr = sec.getBoundingClientRect();
    const W = Math.round(sr.width), H = Math.round(sr.height + OVER);
    if (W < 2 || H < 2) return;
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    const chico = W < 760;
    body.setAttribute('stroke-width', chico ? '2.5' : '3.1');
    // el degrade cambia de papel a tinta en el borde REAL de seccion
    const qq = OVER / H;
    const stops = (k, arr) => {
      const g = q('[data-eq-grad="' + k + '"]');
      if (!g) return;
      g.setAttribute('y2', H);
      const ss = g.querySelectorAll('stop');
      arr.forEach((v, i) => { if (ss[i + 1]) ss[i + 1].setAttribute('offset', v.toFixed(4)); });
    };
    stops('body', [qq * 0.45, qq * 0.85, qq, qq]);
    stops('lo', [qq * 0.45, qq, qq]);
    stops('hi', [qq, qq]);

    const pad = parseFloat(getComputedStyle(band).paddingLeft) || 24;
    const cx = Math.max(6, Math.min(16, pad * 0.25));
    const R = chico ? 20 : 34;
    // la regla del campo, o el renglon "Anotado" si el formulario ya se fue (los ocultos miden 0)
    const rule = qa('[data-eq-rule], [data-eq-bol-okrow]').find((el) => el.offsetParent !== null) || q('[data-eq-field]');
    const sep = chico ? 7 : 10;
    const yc = rule ? Math.round(off(rule).b + OVER + sep) : Math.round(H * 0.62);
    const amp = Number(sec.dataset.temblor) || 0;
    const d = suave(puntos(cx, W - cx, yc, R, H, amp));

    cables().concat([q('[data-eq-tail-a]'), q('[data-eq-tail-b]')].filter(Boolean)).forEach((p) => p.setAttribute('d', d));
    L = body.getTotalLength();
    cables().forEach((p) => {
      p.style.strokeDasharray = L + ' ' + (L + 2);
      if (!corrio) p.style.strokeDashoffset = L;
    });

    const N = 300, pts = [];
    for (let i = 0; i <= N; i++) { const l = (L * i) / N, p = body.getPointAtLength(l); pts.push({ l, x: p.x, y: p.y }); }
    const firstY = (y) => { const s2 = pts.find((p) => p.y >= y); return s2 ? s2.l : L; };
    const firstX = (x) => { const s2 = pts.find((p) => p.x >= x && Math.abs(p.y - yc) < 16); return s2 ? s2.l : L; };

    blocks = qa('[data-eq-reg]').map((el) => {
      const r = { left: off(el).x + sr.left, top: off(el).y + sr.top };
      const modo = el.getAttribute('data-eq-reg');
      return { el, l: modo === 'x' ? firstX(r.left - sr.left - 5) : firstY(r.top - sr.top + OVER + 10) };
    });
    if (rule) { const rr = off(rule); lrA = firstX(rr.x); lrB = firstX(rr.r); }
    const f = q('[data-eq-wash]') || q('[data-eq-field]');
    if (f) { const fr = off(f); lwA = firstX(fr.x - 4); lwB = firstX(fr.r + 4); }
  };

  const marcar = () => { const l = q('[data-eq-label]'); if (l) l.style.color = 'var(--eq-ink)'; };

  const settle = () => {
    corrio = true;
    cables().forEach((p) => { p.style.transition = 'none'; p.style.strokeDashoffset = '0'; });
    const wash = q('[data-eq-wash]');
    if (wash) { wash.style.transition = 'none'; wash.style.clipPath = 'inset(0)'; }
    const ink = q('[data-eq-rule-ink]');
    if (ink) { ink.style.transition = 'none'; ink.style.clipPath = 'inset(0)'; }
    qa('[data-eq-reg]').forEach((el) => { el.style.transition = 'none'; el.style.clipPath = OPEN; el.style.transform = 'none'; el.style.opacity = '1'; });
    marcar();
  };

  // La entrada cuenta como "vista" recien cuando la corriente LLEGA al club, no
  // al empezar a tender el cable: si el usuario se iba en el medio, al volver
  // el boletin aparecia asentado sin chispa y el club quedaba apagado esperando
  // una corriente que ya no iba a salir.
  const corriente = (color) => {
    marcarVisto('boletin');
    try { window.dispatchEvent(new CustomEvent('eq:corriente', { detail: { color: color || null } })); } catch (e) {}
  };
  const lavar = (hex, k) => {
    const h = hex.replace('#', '');
    const n = parseInt(h.length === 3 ? h.split('').map((c) => c + c).join('') : h, 16);
    const c = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((v) => Math.round(v + (255 - v) * k));
    return 'rgb(' + c.join(',') + ')';
  };
  const tenir = (color) => {
    const mid = q('[data-eq-chispa-mid]'), edge = q('[data-eq-chispa-edge]');
    const ta = q('[data-eq-tail-a]'), tb = q('[data-eq-tail-b]');
    const claro = color ? lavar(color, 0.72) : '#dff1f6';
    const canto = color || '#4dabc4';
    if (mid) mid.setAttribute('stop-color', claro);
    if (edge) edge.setAttribute('stop-color', canto);
    if (ta) ta.style.stroke = color ? lavar(color, 0.55) : '#cfeaf2';
    if (tb) tb.style.stroke = canto;
  };
  const chispa = (color) => {
    const body = q('[data-eq-cable-body]'), c = q('[data-eq-chispa-dot]');
    if (!body || !c || !L || lento) { if (lento) corriente(color); return; }
    if (rafC) cancelAnimationFrame(rafC);
    tenir(color);
    const V = Math.max(200, Number(sec.dataset.chispaVel) || 1450);
    const T = (L / V) * 1000;
    c.setAttribute('r', Math.max(2.5, (Number(sec.dataset.chispa) || 10) / 2));
    const tails = [[q('[data-eq-tail-a]'), 30, 0.9], [q('[data-eq-tail-b]'), 62, 0.45]];
    const t0 = performance.now();
    let paso = false;
    const step = (now) => {
      const k = Math.min(1, (now - t0) / T);
      const head = L * k;
      const p = body.getPointAtLength(head);
      c.setAttribute('cx', p.x.toFixed(1)); c.setAttribute('cy', p.y.toFixed(1));
      const fade = k > 0.93 ? Math.max(0, (1 - k) / 0.07) : 1;
      c.style.opacity = fade;
      // la corriente se entrega al club en el cuadro exacto en que la cabeza sale
      if (!paso && k > 0.93) { paso = true; corriente(color); }
      tails.forEach((t) => {
        if (!t[0]) return;
        t[0].style.strokeDasharray = t[1] + ' ' + (L + t[1]);
        t[0].style.strokeDashoffset = (t[1] - head).toFixed(1);
        t[0].style.opacity = t[2] * fade;
      });
      if (k < 1) rafC = requestAnimationFrame(step);
      else { rafC = 0; c.style.opacity = '0'; }
    };
    rafC = requestAnimationFrame(step);
  };
  const chispaClick = (color) => {
    const t = performance.now();
    if (tChispa && t - tChispa < 5000) return;
    tChispa = t;
    chispa(color);
  };

  const run = () => {
    if (corrio) return;
    corrio = true;
    if (io) { io.disconnect(); io = null; }
    clearInterval(guard);
    layout();
    const trazos = cables();
    if (!trazos.length || !L) { settle(); return; }
    const ms = (l) => Math.max(0, Math.round((l / SPEED) * 1000));
    const total = ms(L);
    timers = [];
    trazos.forEach((p) => {
      p.style.transition = 'none';
      const a = p.animate([{ strokeDashoffset: L }, { strokeDashoffset: 0 }], { duration: total, easing: 'linear', fill: 'both' });
      a.onfinish = () => { p.style.strokeDashoffset = '0'; try { a.cancel(); } catch (err) {} };
    });
    blocks.forEach((b) => {
      timers.push(setTimeout(() => { b.el.style.clipPath = OPEN; b.el.style.transform = 'translateY(0)'; b.el.style.opacity = '1'; }, ms(b.l)));
    });
    const wash = q('[data-eq-wash]');
    if (wash && lwB != null) {
      const cruce = Math.max(120, ms(lwB) - ms(lwA));
      wash.style.transition = 'clip-path ' + cruce + 'ms linear';
      timers.push(setTimeout(() => { wash.style.clipPath = 'inset(0)'; }, ms(lwA)));
      timers.push(setTimeout(marcar, ms(lwB)));
    }
    const ink = q('[data-eq-rule-ink]');
    if (ink && lrB != null) {
      const largo = Math.max(80, ms(lrB) - ms(lrA));
      ink.style.transition = 'clip-path ' + largo + 'ms linear';
      timers.push(setTimeout(() => { ink.style.clipPath = 'inset(0)'; }, ms(lrA)));
    }
    // el circuito queda cerrado y recien despues corre la corriente
    // si venimos de una suscripcion confirmada por recarga, esta primera
    // corriente ya sale verde en vez de mandar dos chispas seguidas
    timers.push(setTimeout(() => { tChispa = performance.now(); chispa(colorPend); colorPend = null; }, total + 620));
  };

  const observar = () => {
    if (io || lento) return;
    // arranca con el 40% de la seccion a la vista (pedido del usuario; era 0.3)
    io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) run(); }), { threshold: 0.4 });
    io.observe(sec);
  };

  // ---- campo y envio (formulario nativo de clientes, por fetch) ----------
  const form = q('[data-eq-bol-form]');
  const mail = q('[data-eq-bol-mail]');
  const thick = q('[data-eq-thick]');
  const estado = (k) => {
    qa('[data-eq-bol-estado]').forEach((el) => { el.hidden = el.dataset.eqBolEstado !== k; });
    // cambio de estado = cambio de geometria: el cable se vuelve a medir y queda asentado
    layout(); if (corrio) settle();
  };
  const onFocus = () => { if (thick) thick.style.transform = 'scaleY(1)'; };
  const onBlur = () => { if (thick && !(mail && mail.value.trim())) thick.style.transform = 'scaleY(0)'; };
  const onSubmit = async (e) => {
    if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
    if (enviando) return;
    const v = ((mail && mail.value) || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { if (mail) mail.reportValidity(); return; }
    enviando = true;
    setTimeout(() => { enviando = false; }, 1500);
    const btn = q('[data-eq-bol-submit]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    try { sessionStorage.setItem('eqBolMail', v); } catch (err) {}
    // Solo la RED decide si hace falta el envio nativo. Antes el try abarcaba
    // tambien la confirmacion: cualquier error despues de un alta exitosa caia
    // en form.submit(), recargaba la pagina y cortaba la chispa ya lanzada.
    let enviado = false;
    try {
      const r = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } });
      // Shopify puede pedir el captcha antispam (challenge): ahi va el envio nativo
      enviado = (r.ok || r.status === 302) && r.url.indexOf('challenge') === -1;
    } catch (err) { enviado = false; }
    if (btn) btn.removeAttribute('aria-busy');
    if (!enviado) {
      // sin fetch: el envio normal, con recarga. Se deja dicho para mandar la
      // corriente verde del otro lado, cuando el cable se vuelva a tender.
      console.warn('[EQ boletin] envio nativo (el fetch no confirmo el alta)');
      try { sessionStorage.setItem('eqBolEnviado', '1'); } catch (e2) {}
      form.submit();
      return;
    }
    // alta confirmada: de aca en adelante nada puede recargar la pagina
    try {
      chispaClick(sec.dataset.colorSub || '#48f09c');
      const ok = q('[data-eq-bol-okmail]');
      if (ok) ok.textContent = v;
      estado('ok');
    } catch (err) {
      console.error('[EQ boletin] confirmacion', err);
    }
  };
  const onCambiar = () => { estado('form'); if (mail) { mail.focus(); onFocus(); } };
  if (mail) { mail.addEventListener('focus', onFocus); mail.addEventListener('blur', onBlur); }
  // Sin evento `submit`: los scripts que Shopify inyecta en content_for_header
  // (proteccion de formularios) escuchan el submit de los formularios de
  // cliente y lo reenvian por su cuenta, y eso recargaba la pagina aunque el
  // fetch ya hubiera dado el alta. Con JS el boton pasa a type=button y Enter
  // se toma a mano; sin JS el markup sigue siendo un formulario comun.
  const btnEnviar = q('[data-eq-bol-submit]');
  if (btnEnviar) btnEnviar.type = 'button';
  const onBtnEnviar = () => onSubmit();
  const onEnter = (e) => { if (e.key === 'Enter') { e.preventDefault(); onSubmit(); } };
  if (btnEnviar) btnEnviar.addEventListener('click', onBtnEnviar);
  if (mail) mail.addEventListener('keydown', onEnter);
  // red por si algo dispara el submit igual: se corta antes que nadie
  const onSubmitCap = (e) => { if (e.target === form) onSubmit(e); };
  if (form) window.addEventListener('submit', onSubmitCap, true);
  q('[data-eq-bol-cambiar]')?.addEventListener('click', onCambiar);
  // confirmado por recarga (captcha o sin JS): el servidor no devuelve el mail, se repone del sessionStorage
  const okmail = q('[data-eq-bol-okmail]');
  if (okmail && !okmail.textContent.trim()) { try { const m = sessionStorage.getItem('eqBolMail'); if (m) okmail.textContent = m; } catch (err) {} }
  const dotIn = () => { const d = q('[data-eq-dot]'); if (d) d.style.background = 'var(--eq-accent)'; };
  const dotOut = () => { const d = q('[data-eq-dot]'); if (d) d.style.background = 'var(--eq-ink)'; };
  q('[data-eq-bol-submit]')?.addEventListener('pointerenter', dotIn);
  q('[data-eq-bol-submit]')?.addEventListener('pointerleave', dotOut);

  layout();
  const onResize = () => { clearTimeout(tRes); tRes = setTimeout(() => { layout(); if (corrio) settle(); }, 150); };
  window.addEventListener('resize', onResize);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { layout(); if (corrio) settle(); });
  // Vuelta del envio nativo: con el captcha antispam de Shopify la confirmacion
  // llega por recarga, asi que la corriente verde se manda de este lado, una
  // sola vez y recien cuando el cable quedo tendido.
  let volvio = false;
  try {
    volvio = sessionStorage.getItem('eqBolEnviado') === '1';
    if (volvio) sessionStorage.removeItem('eqBolEnviado');
  } catch (err) { volvio = false; }
  const okVisible = qa('[data-eq-bol-estado]').some((el) => el.dataset.eqBolEstado === 'ok' && !el.hidden);
  if (volvio && okVisible) colorPend = sec.dataset.colorSub || '#48f09c';

  // la entrada se ve una vez por sesion: al volver a la home el cable ya esta tendido
  if (lento || yaVisto('boletin')) settle();
  else {
    observar();
    requestAnimationFrame(observar);
    // red de seguridad: solo puede actuar con el 40% de la seccion a la
    // vista, igual que el observer (si la seccion es mas alta que la
    // pantalla, el 40% de la pantalla: el de la seccion no entraria)
    guard = setInterval(() => {
      if (corrio) { clearInterval(guard); return; }
      observar();
      const r = sec.getBoundingClientRect();
      const visto = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
      if (visto >= Math.min(r.height, window.innerHeight) * 0.4) { clearInterval(guard); run(); }
    }, 900);
  }
  // cable ya tendido (vuelta sin entrada): la corriente verde sale sola
  if (colorPend && corrio) {
    timers.push(setTimeout(() => { tChispa = performance.now(); chispa(colorPend); colorPend = null; }, 320));
  }

  return () => {
    if (io) io.disconnect();
    window.removeEventListener('resize', onResize);
    clearInterval(guard); clearTimeout(tRes);
    timers.forEach(clearTimeout);
    if (rafC) cancelAnimationFrame(rafC);
    if (form) window.removeEventListener('submit', onSubmitCap, true);
    if (btnEnviar) btnEnviar.removeEventListener('click', onBtnEnviar);
    if (mail) mail.removeEventListener('keydown', onEnter);
  };
});
